<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Tarefas Mobilidades</h1>

    <SGPTabelaComponent
      v-if="listagem.length"
      :colunas="colunas"
      :dados="listagem"
      :usuarioPodeExcluir="false"
      :usuarioPodeEditar="false"
      :somenteLeitura="true"
      @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
      @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
      @sgpTabelaDeletarSelecionadoEmit="deletarSelecionado"
      @sgpTabelaModalCadastrarEmit="cadastrarTarefaMobilidade"
      :filtroText="true"
    >
      <template v-slot:item.redirecionar="{ item }">
        <SGPFormBotaoComponent
          fab
          rounded
          color="warning"
          :to="item.redirecionar"
          x-small
        >
          <v-icon color="white" small>mdi-link </v-icon>
        </SGPFormBotaoComponent>
      </template>
      <template v-slot:item.modalGenerica="{ item }">
        <SGPFormBotaoComponent
          fab
          rounded
          color="warning"
          :to="item.modalGenerica"
          x-small
          @click="cadastrarTarefaMobilidade(item)"
        >
          <v-icon color="white" small>mdi-link </v-icon>
        </SGPFormBotaoComponent>
      </template>
    </SGPTabelaComponent>

    <SGPAlertaComponent v-else></SGPAlertaComponent>

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="full"
      titulo="Gestão da Mobilidade (Conclusões e formulários)"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioMobilidadeComponent :tarefa="tarefaMobilidade"/>
    </SGPModalComponent> 

    <SGPLoadingComponent v-if="loadingTarefas"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import FormularioMobilidadeComponent from '../components/FormularioMobilidadeComponent'
import moduleReload from '@/common/mixins/module-reload.js'

export default {
  name: 'TarefaMobilidadePage',
  components: {FormularioMobilidadeComponent},
  mixins: [moduleReload],

  data () {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      tarefasMobilidadesSelecionadas: [],
      abrirModal: false,
      deletarDados: false,
      tipoFormulario: 'salvar',
      tarefaMobilidade: {}
    }
  },

  created () {
    this.listarTarefas();
    // this.listarTiposTarefas();
    // this.listarConclusoes();
    // this.listarFormularios();
    // this.listarTiposParalelismo();
  },

  computed: {
    ...mapGetters('ctrlTarefas', ['listaDeTarefas','loadingTarefas']),
  
    listagem(){
      return this.listaDeTarefas
          .filter(tarefa => tarefa.deleted_at == null)
          .map(tarefa => {
          tarefa.redirecionar = `/workflow/tarefas-mobilidades/${tarefa.id}`;
          tarefa.associar =  `/workflow/tarefas-opcoes-tratativas/${tarefa.id}`;

          tarefa.modalGenerica = false;
          if(typeof tarefa.ctrl_tarefas_mobilidades !== "undefined") {
            if(tarefa.ctrl_tarefas_mobilidades.length){
              tarefa.modalGenerica = true;
            }
          }

          return tarefa;
      });
    },

    colunas () {
      return [
        {
          key: 'tarefa',
          label: 'Tarefa',
          sortable: false
        },
        // {
        //   key: 'redirecionar',
        //   label: 'Tarefas Associadas',
        //   sortable: false,
        //   align: 'center'
        // },
        {
          key: 'modalGenerica',
          label: 'Gestão da mobilidade',
          sortable: false,
          align: 'center'
        },
        // {
        //   key: 'associar',
        //   label: 'Gestão Opções',
        //   sortable: false,
        //   align: 'center'
        // },
      ]
    }
  },

  methods: {
    ...mapActions('ctrlTarefas', 
    [
      'listarTarefas',
      'listarTipoTarefas',
    ]),
    // ...mapActions('ctrlConclusoes', 
    // [
    //   'listarConclusoes',
    // ]),
    // ...mapActions('ctrlFormularios', 
    // [
    //   'listarFormularios',
    // ]),

    // ...mapActions('ctrlTiposParalelismo', 
    // [
    //   'listarTiposParalelismo',
    // ]),

    gerenciadorDeSelecionados (selecionados) {
      this.tarefasMobilidadesSelecionadas = selecionados;
    },

    fecharModal () {
      this.abrirModal = false;
    },

    cadastrarTarefaMobilidade (tarefa) {
      this.tarefaMobilidade = tarefa;
      this.abrirModal = true;
    },

    reloadData () {
      this.listarTarefas();
    }
  }
}
</script>
